// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-section-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
@media (max-width: 992px) {
  .slide-section-wrapper {
    height: unset;
  }
}
.slide-section-wrapper .slide-section {
  display: flex;
  height: 100%;
  overflow-y: scroll;
  flex-direction: column;
}
.slide-section-wrapper .slide-section .single-agenda-item {
  cursor: pointer;
  margin-bottom: 1rem;
}
.slide-section-wrapper .slide-section .single-agenda-item:hover {
  color: var(--primary-color);
}
.slide-section-wrapper .slide-section .single-agenda-item__title-img img {
  width: 100%;
  height: auto;
}
.slide-section-wrapper .drawer-page {
  width: 100%;
  flex-shrink: 0;
}
@media (max-width: 992px) {
  .slide-section-wrapper .drawer-page {
    height: 100%;
  }
}
.slide-section-wrapper .show-detail .button-container {
  margin: 1rem 0;
}
.slide-section-wrapper .show-detail .media-container {
  display: flex;
  flex-direction: column;
  height: 30%;
  overflow-y: scroll;
  gap: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/SlideSection/SlideSection.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AADJ;AAGI;EANJ;IAOQ,aAAA;EAAN;AACF;AAEI;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAAR;AAEQ;EACI,eAAA;EACA,mBAAA;AAAZ;AAEY;EACI,2BAAA;AAAhB;AAIgB;EACI,WAAA;EACA,YAAA;AAFpB;AAQI;EACI,WAAA;EACA,cAAA;AANR;AAQQ;EAJJ;IAKQ,YAAA;EALV;AACF;AASQ;EACI,cAAA;AAPZ;AAUQ;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AARZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
